import { Injectable } from '@angular/core';
import { NzTreeBaseService } from './nz-tree-base.service';

@Injectable()
export class NzTreeService extends NzTreeBaseService {}
